// Store the previous page URL for "Continue Shopping" functionality
document.addEventListener('DOMContentLoaded', function() {
  const currentPath = window.location.pathname;
  
  // Don't store cart or checkout pages as previous pages
  if (!currentPath.includes('/cart') && !currentPath.includes('/checkout')) {
    try {
      localStorage.setItem('previousPage', currentPath);
    } catch (e) {
      // Silently fail if localStorage is not available
    }
  }

  // Get the previous page from localStorage with fallback
  function getPreviousPage() {
    try {
      return localStorage.getItem('previousPage') || '/collections/our-coffee';
    } catch (e) {
      return '/collections/our-coffee';
    }
  }

  // Direct binding function for continue shopping elements
  function bindContinueShoppingAction(element) {
    if (element.hasAttribute('data-continue-shopping-bound')) {
      return;
    }
    
    const previousPage = getPreviousPage();
    element.setAttribute('data-continue-shopping-bound', 'true');
    
    if (element instanceof HTMLAnchorElement) {
      element.href = previousPage;
    } else if (element instanceof HTMLButtonElement) {
      element.addEventListener('click', function() {
        window.location.href = previousPage;
      });
    }
  }

  // Update all "Continue Shopping" links with the previous page URL
  function updateContinueShoppingLinks() {
    // Handle all elements with the continue-shopping class
    document.querySelectorAll('.continue-shopping:not([data-continue-shopping-bound])')
      .forEach(bindContinueShoppingAction);
    
    // Handle legacy links that might not have the class but point to collections/our-coffee or our-coffees
    document.querySelectorAll('a[href*="/collections/our-coffee"]:not([data-continue-shopping-bound]), a[href*="/collections/our-coffees"]:not([data-continue-shopping-bound])')
      .forEach(link => {
        if (link.textContent.trim() === window.theme?.strings?.continueShoppingText || 
            link.textContent.includes('Continue Shopping')) {
          bindContinueShoppingAction(link);
        }
      });
  }

  // Initial run
  updateContinueShoppingLinks();

  // Run when cart is updated
  document.addEventListener('cart:updated', updateContinueShoppingLinks);
  
  // One-time delayed execution for dynamically loaded elements
  setTimeout(updateContinueShoppingLinks, 1000);
}); 